import { render, staticRenderFns } from "./TableRowSelectSupport.vue?vue&type=template&id=2c4f2050&"
import script from "./TableRowSelectSupport.vue?vue&type=script&lang=js&"
export * from "./TableRowSelectSupport.vue?vue&type=script&lang=js&"
import style0 from "./TableRowSelectSupport.vue?vue&type=style&index=0&id=2c4f2050&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports